import { ActionType, Action, loadState } from "../actions/types"

const initialLoadState: loadState = {
  loadDetails: {
    code: "",
    name: "",
    permalink: ""
  }
}

const loadDetailsReducer = (
  state: loadState = initialLoadState,
  action: Action
) => {
  switch (action.type) {
    case ActionType.SET_LOAD_STATUS:
      return {
        ...state,
        loadDetails: action.payload
      }
    default:
      return state
  }
}

export default loadDetailsReducer
